import { FormattedMessage } from 'react-intl';

import { PremiumTagShell } from './premium-tag-shell';
import shellStyle from './premium-tag-shell.module.css';
import { SHOP_PROMISE_COLOR } from './shop-promise-constants';
import shopPromiseIcon from './shop-promise-icon.svg';
import { messages } from './messages';

export const ShopPromiseTag = () => {
  return (
    <PremiumTagShell
      color={SHOP_PROMISE_COLOR}
      logo={<img alt='' className={`${shellStyle['tag-logo']} ${shellStyle['tag-logo-balanced']}`} src={shopPromiseIcon} />}
    >
      <FormattedMessage {...messages.shopPromiseLabel} />
    </PremiumTagShell>
  );
};
